import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutRequest } from '../store/auth/actions';
import { RootState } from '../store/reducers';
import { LayoutDashboard, Upload, FileText, Search, Sparkles, LogOut, ShieldCheck, ClipboardCheck } from 'lucide-react';
import logoTca from '../logo-tca.png';
import './Sidebar.css';

const navItems = [
  { path: '/espace-tca', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
  { path: '/espace-tca/numerisation', label: 'Numérisation', icon: Upload, end: false },
  { path: '/espace-tca/decisions', label: 'Décisions', icon: FileText, end: false },
  { path: '/espace-tca/recherche', label: 'Recherche', icon: Search, end: false },
  { path: '/espace-tca/controle-qualite', label: 'Contrôles qualité', icon: ClipboardCheck, end: false },
];

interface SidebarProps {
  onNavClick?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onNavClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.auth.user);

  const roles = (user?.role || []).map((r: any) => r.name);
  const isAdmin = roles.includes('admin') || roles.includes('superadmin');

  const handleLogout = () => {
    dispatch(logoutRequest(navigate));
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-top">
        <div className="sidebar-logo">
          <img src={logoTca} alt="TCA" className="sidebar-logo-img" />
          <div className="sidebar-logo-text">
            <span className="sidebar-logo-name">TCA</span>
            <span className="sidebar-logo-sub">Anonymisation</span>
          </div>
        </div>

        <div className="sidebar-section-label">ESPACE AGENT</div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`}
              onClick={onNavClick}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {isAdmin && (
          <>
            <div className="sidebar-section-label" style={{ marginTop: 24 }}>ADMINISTRATION</div>
            <nav className="sidebar-nav">
              <NavLink
                to="/espace-admin"
                className="sidebar-nav-item sidebar-switch-link"
                onClick={onNavClick}
              >
                <ShieldCheck size={20} />
                <span>Espace Admin</span>
              </NavLink>
            </nav>
          </>
        )}
      </div>

      <div className="sidebar-bottom">
        <div className="sidebar-ia-card">
          <Sparkles size={20} className="sidebar-ia-icon" />
          <div>
            <strong>IA juridique active</strong>
            <p>Anonymisation et résumé automatique des décisions.</p>
          </div>
        </div>

        <button className="sidebar-logout" onClick={handleLogout}>
          <LogOut size={20} />
          <span>Déconnexion</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
